import React from 'react';
import {
  MainContentWrapper,
  ParcelDetailsContainer,
  ParcelDetailsBox,
  TrackingDetailsContainer,
  AdditionalContentContainer,
} from './ShipmentLayout.styles';

interface ShipmentLayoutProps {
  parcelDetails: React.ReactNode;
  trackingDetails: React.ReactNode;
  additionalContent?: React.ReactNode;
}

export const ShipmentLayout: React.FunctionComponent<ShipmentLayoutProps> = (
  props,
) => {
  const { parcelDetails, trackingDetails, additionalContent } = props;

  return (
    <>
      <MainContentWrapper>
        <ParcelDetailsContainer>
          <ParcelDetailsBox>{parcelDetails}</ParcelDetailsBox>
        </ParcelDetailsContainer>
        <TrackingDetailsContainer>{trackingDetails}</TrackingDetailsContainer>
      </MainContentWrapper>
      {additionalContent && (
        <AdditionalContentContainer>
          {additionalContent}
        </AdditionalContentContainer>
      )}
    </>
  );
};
